import instance from "../api/api";
import instancePos from "../api/apiV2";
import { useQuery } from "@tanstack/react-query";

export const useGetAllCategories= (body) => {
  return useQuery({
    queryKey: ["allCategories"],
    queryFn: async () => {
      const response = await instance.post(`/get-all-ai-categories`, body);
      return response.data;
    }
  })
}

export const useGetRestaurantCatageories= (body) => {
  return useQuery({
    queryKey: ["allresCategories"],
    queryFn: async () => {
      const response = await instancePos.post(`/restaurant-category-type-detail`, body);
      return response.data;
    }
  })
}

const getMenuMix = async ({pageNum, pageSize, restaurant_id, filters}) => {
  const payload = {
    page_index: pageNum - 1,
    page_size: pageSize,
    restaurant_id: restaurant_id,
    filters: filters,
  };

  const response = await instance.post(`/get-menu-mix`, payload);
  return response.data;
};

const searchMenuMix = async ({restaurant_id, naame, filters}) => {
  const payload = {
    restaurant_id: restaurant_id,
    name: naame,
    filters: filters,
  };

  const response = await instance.post(`/search-menu-mix`, payload);
  return response.data;
};

const getLaborClassification = async ({pageNum, pageSize, restaurant_id}) => {
  const payload = {
    page_index: pageNum - 1,
    page_size: pageSize,
    restaurant_id: restaurant_id,
  };

  const response = await instance.post(`/get-labour-classification`, payload);
  return response.data;
};

const searchLabor = async ({restaurant_id, title}) => {
  const payload = {
    restaurant_id: restaurant_id,
    title: title,
  };

  const response = await instance.post(`/search-labor`, payload);
  return response.data;
}

const getDiscountClassification = async ({pageNum, pageSize, restaurant_id}) => {
  const payload = {
    page_index: pageNum - 1,
    page_size: pageSize,
    restaurant_id: restaurant_id,
  };

  const response = await instance.post(`/get-discount-classification`, payload);
  return response.data;
};

const searchDiscount = async ({restaurant_id, name}) => {
  const payload = {
    restaurant_id: restaurant_id,
    name: name,
  };

  const response = await instance.post(`/search-discount`, payload);
  return response.data;
}

const changeMenuMixCategory = async (body) => {
  const response = await instancePos.post(`/classify_pmix`, body)
  return response.data
};

const changeLaborClassCategory = async (labor_id, category,restaurant_id) => {
  const body = {
    labor_id: labor_id,
    category: category,
    restaurant_id:restaurant_id
  };
  const response = await instancePos.post(`/classify_labor`, body)
  return response.data
};

const changeDiscountCategory = async (discount_id, category,restaurant_id) => {
  const body = {
    discount_id: discount_id,
    category_id: category,
    restaurant_id:restaurant_id
  };
  const response = await instancePos.post(`/classify_discount`, body)
  return response.data
};

const exportExcel = async (body) => {
  const response = await instancePos.post(`/export_discount_classification_excel`, body);
  return response.data;
}

const importExcel = async (body) => {
  
  const response = await instancePos.post(`/import_discount_classification_excelll`, body);
  return response.data;
}

export {
  getMenuMix,
  getLaborClassification,
  changeLaborClassCategory,
  changeMenuMixCategory,
  searchLabor,
  searchMenuMix,
  getDiscountClassification,
  searchDiscount,
  changeDiscountCategory,
  exportExcel,
  importExcel,
};
